import React, { useState } from 'react';

import { ChangeTaskFilter, TaskFilters } from 'entities/task';
import { useAppSelector } from 'store';

import { SelectedItem } from '../../../../widgets/TaskHeader/types/taskHeader';
import { getProjectAndEstimates } from '../helpers/getProjectAndEstimates';
import { searcher } from '../helpers/searcher';

export const useProjectsFilter = (onFilteredData: ChangeTaskFilter, filteredData: TaskFilters) => {
    const { projectsForFilter, projectsForFilterGantt, isShowGanttTabs } = useAppSelector(
        (state) => state.tasksInformationReducer
    );
    const [input, setInput] = useState('');

    const onInput =  (_name: string, value: string) => setInput(value)

    const projects =
        (isShowGanttTabs && projectsForFilterGantt ? projectsForFilterGantt : projectsForFilter) ||
        [];
    const allItems = getProjectAndEstimates(projects);
    const selectedItem =
        allItems.find((item) =>
            item.isProject ? item.id === filteredData.projects : item.id === filteredData.estimate
        ) || null;
    const projectAndEstimates = input ? searcher(projects, input) : allItems;

    const resetButton = () => onFilteredData('projects', null);
    const resetIconButton = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        resetButton();
    };
    const changeSelectedItem = (item: SelectedItem) => {
        const isSelected =
            selectedItem?.id === item.id && selectedItem.isProject === item.isProject;
        if (item.isProject) onFilteredData('projects', isSelected ? null : item.id);
        else onFilteredData('estimate', isSelected ? null : item.id);
    };
    return {
        selectedItem,
        resetIconButton,
        changeSelectedItem,
        projectAndEstimates,
        input,
        onInput,
        resetButton,
    };
};
